<template>
  <div class="">
    <div
      v-if="!isHidden || localShow"
      class="tw-flex tw-space-x-2 tw-justify-center"
      role="alert"
    >
      <div
        id="static-example"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        data-mdb-autohide="false"
        :class="[
          `tw-mb-4
        tw-bg-white
        tw-mx-auto
        tw-w-96
        tw-max-w-full
        tw-text-sm
        tw-pointer-events-auto
        tw-bg-clip-padding tw-rounded-lg
        tw-block
        tw-shadow`,
          color,
        ]"
      >
        <div
          :class="[
            `tw-flex
          tw-justify-between
          tw-items-center tw-py-2 tw-px-3
          tw-bg-clip-padding
          tw-border-b
          tw-border-gray-200
          tw-rounded-t-lg`,
            color,
          ]">
          <div
            v-if="resolvedVariant"
            :class="[
              `tw-inline-flex tw-flex-shrink-0
          tw-justify-center tw-items-center
          tw-w-6 tw-h-6
          tw-rounded-lg
          tw-mr-2`,
              iconColor,
            ]
            ">
            <AlertCircleIcon v-if="resolvedVariant === 'danger'" :size="iconSize" />
            <AlertTriangleIcon v-else-if="resolvedVariant === 'warning'" :size="iconSize" />
            <CheckIcon v-else-if="resolvedVariant === 'success'" :size="iconSize" />
            <AlertTriangleIcon v-else-if="resolvedVariant === 'info'" :size="iconSize" />
          </div>
          <p class="tw-font-bold">{{ title }}</p>
          <div class="tw-flex tw-items-center tw-ml-auto">
            <button
              aria-label="Close"
              class="
              tw-ml-auto
              tw-rounded-lg
              tw-inline-flex
              tw-focus:ring-gray-300
              tw-focus:ring-2
              tw-text-gray-400
              tw-hover:text-gray-900
              tw-hover:bg-gray-100
            "
              type="button"
              @click="onClose"
            >
              <span class="sr-only">
                Close
              </span>
              <XIcon :size="iconSize" class="tw-text-gray-800"/>
            </button>
          </div>
        </div>
        <div
          :class="[
            `tw-p-3
        tw-rounded-b-lg
        tw-break-words`,
            bodyColor,
          ]">
          <div v-if="isStatic">
            <div v-if="typeof content === 'string'">{{ content }}</div>
            <div v-else><ToastContent :content="content" /></div>
            <content />
          </div>
          <slot v-else></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ToastContent from './toast-content.vue'
  import {
    CheckIcon,
    AlertTriangleIcon,
    AlertCircleIcon,
    XIcon,
  } from 'vue-feather-icons'
  import { AVAILABLE_COLOURS, AVAILABLE_VARIANTS } from '@components/plugins/Toast/constants'

  const COLOUR_DEFAULT = 'green';


  export default {
    name: 'FabricToaster',
    components: {
      CheckIcon,
      ToastContent,
      AlertTriangleIcon,
      AlertCircleIcon,
      XIcon,
    },
    props: {
      badge: {
        type: [String, Boolean],
        default: false,
      },
      content: {
        type: [String, Object],
        default: '',
      },
      id: {
        type: [String],
        default: '',
      },
      title: {
        type: [String],
        default: '',
      },
      isHidden: {
        type: [Boolean],
        default: true,
      },
      variant: {
        type: [String, Boolean],
        validator: function (value) {
          // The value must match one of these strings
          return (AVAILABLE_VARIANTS.includes(value) || !value)
        },
        default: false,
      },
      colour: {
        type: [String],
        validator: function (value) {
          // The value must match one of these strings
          return AVAILABLE_COLOURS.includes(value)
        },
        default: COLOUR_DEFAULT,
        required: true,
      },
      onClose: {
        type: [Function],
        default: () => {},
      },
      isStatic: {
        type: [Boolean],
        default: false
      },
      localShow: {
        type: [Boolean],
        default: false
      },
    },
    data() {
      return {
        iconSize: '1.35x',
      }
    },
    computed: {
      resolvedColour() {
        if (!AVAILABLE_COLOURS.includes(this.colour)){
          return COLOUR_DEFAULT
        }
        return this.colour
      },
      resolvedVariant() {
        if (!AVAILABLE_VARIANTS.includes(this.variant)){
          return false
        }
        return this.variant
      },
      iconColor() {
        return `tw-bg-${this.resolvedColour}-200`
      },
      color() {
        return `tw-text-${this.resolvedColour}-500 tw-bg-${this.resolvedColour}-100`
      },
      bodyColor() {
        return `tw-bg-${this.resolvedColour}-50`
      },
      usedColours(){
        return {
          'bg-50': [
            'tw-bg-orange-50',
            'tw-bg-red-50',
            'tw-bg-green-50',
            'tw-bg-blue-50',
          ],
          'bg-100': [
            'tw-bg-orange-100',
            'tw-bg-red-100',
            'tw-bg-green-100',
            'tw-bg-blue-100',
          ],
          'bg-200': [
            'tw-bg-orange-200',
            'tw-bg-red-200',
            'tw-bg-green-200',
            'tw-bg-blue-200',
          ],
          'text-500': [
            'tw-text-orange-500',
            'tw-text-red-500',
            'tw-text-green-500',
            'tw-text-blue-500',
          ]
        }
      }
    },
  }
</script>
